import { atomWithReset } from "jotai/utils";

export const helpContextMenuAtom = atomWithReset({});
